module.exports = __webpack_public_path__ + "static/media/tractor-1.e85ea725.jpg";